import BaseRequest from "@/utils/http/index";

let request = new BaseRequest("");

let prefix = "/api/patent";
let bsPreFix = "/bsapi/";

// 获取字典的值
export const sysDict = (params) => {
  return request.post("/api/brace/dict/findByEntity", params);
};
// 图片上传
export const imgUpload = (params) => {
  return request.postMul("/bsapi/upload/upload", params);
};
// 取消收藏接口
export const cancelCollection = (params) => {
  return request.post(prefix + "/collection/cancelCollection", params);
};

// 首页专利未登录列表
export const queryFirstPageList = (params) => {
  return request.post(prefix + "/patenth5/patentSearch/queryFirstPageList", {
    ...params,
  });
};
// 首页专利列表
export const queryPatentList = (params) => {
  return request.post(prefix + "/patentSearch/queryPatentList", {
    ...params,
    appKey: "quandashi4106565062",
  });
};

// 保存搜索记录， 调用接口后自动保存最近记录
export const saveHistoricalSearchRecord = (params) => {
  return request.post(
    prefix + "/patentSearch/saveHistoricalSearchRecord",
    params
  );
};

// 查询搜索记录
export const getHistoricalSearchRecord = (params) => {
  return request.post(
    prefix + "/patentSearch/getHistoricalSearchRecord",
    params
  );
};

// 二维码操作
export const createQrcode = (params) => {
  return request.post("/api/brace/bsMa/wxaCode", params);
};

// 根据id同步用户数据
export const synchronizeUser = (params) => {
  return request.post(prefix + "/user/synchronizeUser", params);
};

// 导出excel
export const exportBrandSourceCell = (params) => {
  return request.post(prefix + "/patentSearch/exportPatentCell", params);
};

// 改价
export const addMarkupRecord = (params) => {
  return request.post(prefix + "/markupRecord/addMarkupRecord", params);
};

// 分享商标
export const addShare = (params) => {
  return request.post(prefix + "/share/addShare", params);
};

// 图片转为base64
export const oss2Base64 = (params) => {
  return request.post("/api/brace/tools/oss2Base64", params);
};
// 查询经纪人信息
export const getSourceAgent = (params) => {
  return request.post(prefix + "/agent/getSourceAgent", params);
};

// 获取首页 推荐经纪人
export const getHomeRecommend = (params) => {
  return request.post(prefix + '/agent/getHomeRecommend', params);
};
// 获取首页 推荐经纪人
export const addRecommendClick = (params) => {
  return request.post(prefix + '/agent/addRecommendClick', params);
};
